import { celepusApiFetch } from './celepusApiClient';
import { ApiError } from './client';
import { KdfParams } from '../crypto/backupCrypto';

interface EncryptionKeyRecord {
  wrapped_master_key: string;
  wrap_nonce: string;
  salt: string;
  kdf_params: KdfParams;
}

interface EncryptionKeyPayload {
  wrapped_master_key: string;
  wrap_nonce: string;
  salt: string;
  kdf_params: KdfParams;
}

// null means the user hasn't set up backup encryption yet — distinct from
// a network/auth failure, which still throws.
const getEncryptionKey = async (): Promise<EncryptionKeyRecord | null> => {
  try {
    return await celepusApiFetch('/api/v1/encryption_key');
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) {
      return null;
    }
    throw e;
  }
};

const createEncryptionKey = (payload: EncryptionKeyPayload): Promise<EncryptionKeyRecord> =>
  celepusApiFetch('/api/v1/encryption_key', { method: 'POST', body: JSON.stringify(payload) });

const rotateEncryptionKey = (payload: EncryptionKeyPayload): Promise<EncryptionKeyRecord> =>
  celepusApiFetch('/api/v1/encryption_key', { method: 'PUT', body: JSON.stringify(payload) });

export type {
  EncryptionKeyRecord,
  EncryptionKeyPayload,
};

export {
  getEncryptionKey,
  createEncryptionKey,
  rotateEncryptionKey,
};
